import request from 'api/requestUtils'
import type { paths } from '@luxuryescapes/contract-cart'
import { mapMultiCartCreateResponse } from './multiCartMappers'
import { mapCheckoutItemToMultiCartPayloadItem } from './multiCartPayloadMappers'

type CreateRequest = Omit<paths['/api/carts/multi-carts']['post']['parameters']['body']['payload'], 'brand'>
type CreateResponse = paths['/api/carts/multi-carts']['post']['responses']['201']['content']['application/json']

export function createMultiCart(name: string, items: Array<App.Checkout.AnyItem>): Promise<App.MultiCartSummary> {
  const payloadItems = items.map(mapCheckoutItemToMultiCartPayloadItem)

  // TODO: remove this and change the villas type check
  const payload = {
    name,
    items: payloadItems,
  } as CreateRequest
  return request.post<CreateResponse, CreateRequest>('/api/carts/multi-carts', payload, { credentials: 'include' }).then(mapMultiCartCreateResponse)
}
